import type { StorefrontNavPath } from "@loot-os/api-contract";
import battlesIcon from "@loot-os/icons/icons/battles";
import boxOpenIcon from "@loot-os/icons/icons/box-open";
import forgeIcon from "@loot-os/icons/icons/forge";
import inventoryIcon from "@loot-os/icons/icons/inventory";
import shieldIcon from "@loot-os/icons/icons/shield";
import userIcon from "@loot-os/icons/icons/user";
import type { IconData } from "@loot-os/icons/types";

/**
 * Each storefront link's icon (the links, their places and labels are `STOREFRONT_NAV_LINKS` in
 * `@loot-os/api-contract`): the phone's tab bar always draws it, the header when the theme's
 * `layout.navLinks` is `icon`. The storefront and the dashboard's theme preview both read it.
 */
export const NAV_ICONS: Record<StorefrontNavPath, IconData> = {
  "/boxes": boxOpenIcon,
  "/battles": battlesIcon,
  "/forge": forgeIcon,
  "/inventory": inventoryIcon,
  "/fairness": shieldIcon,
  "/account": userIcon,
};
